import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchPresets, Preset } from '../../utils/axios/api';
import { initAuth, login, logout, resetAuth } from './auth-slice';

interface PresetsState {
  items: Preset[];
}

const initialState: PresetsState = {
  items: [],
};

export const refreshPresets = createAsyncThunk('presets/refresh', fetchPresets);

const presetsSlice = createSlice({
  name: 'presets',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resetAuth, () => initialState)
      .addCase(logout.fulfilled, () => initialState)
      .addCase(initAuth.rejected, () => initialState)
      .addCase(initAuth.fulfilled, (state, action) => {
        state.items = action.payload.presets;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.items = action.payload.presets;
      })
      .addCase(refreshPresets.fulfilled, (state, action) => {
        state.items = action.payload;
      });
  },
});

export default presetsSlice.reducer;
